import axios from '@/api/http';
import base from '@/api//base';
const custom = {
	// 分页请求所有数据-客户
	CustomerPage(params){
		return axios.post(`${base.baseURL}/Customer/page`,params);
	},
	// 新增数据-客户
	CustomerInsert(params){
		return axios.post(`${base.baseURL}/Customer/insert`,params);
	},
	// 新增数据-客户导入
	CustomerExcelInit(params){
		return axios.post(`${base.baseURL}/Customer/excel/init`,params);
	},
	// 修改数据-客户
	CustomerUpdate(params){
		return axios.post(`${base.baseURL}/Customer/update`,params);
	},
	// 修改数据-客户修改个人信息
	CustomerUpdateForme(params){
		return axios.post(`${base.baseURL}/Customer/update/me`,params);
	},
	// 删除数据-客户
	CustomerDeleteById(id){
		return axios.post(`${base.baseURL}/Customer/delete/${id}`);
	},
  // 跟进记录
	// 分页请求所有数据-跟进记录
	CustomerContactRecordPage(params){
		return axios.post(`${base.baseURL}/CustomerContactRecord/page`,params);
	},
	// 新增数据-跟进记录
	CustomerContactRecordInsert(params){
		return axios.post(`${base.baseURL}/CustomerContactRecord/insert`,params);
	},
	// 修改数据-跟进记录
	CustomerContactRecordUpdate(params){
		return axios.post(`${base.baseURL}/CustomerContactRecord/update`,params);
	},
	// 删除数据-跟进记录
	CustomerContactRecordDeleteById(id){
		return axios.post(`${base.baseURL}/CustomerContactRecord/delete/${id}`);
	},
	// 更改跟进状态-跟进记录
	CustomerContactRecordUpdateStatusByIdWithStatus(id,status){
		return axios.get(`${base.baseURL}/CustomerContactRecord/updateStatus/${id}/${status}`);
	},
	// 轮询调用提醒跟进-跟进记录
	CustomerContactRecordPolling(){
		return axios.get(`${base.baseURL}/CustomerContactRecord/polling`);
	},
	// 客户升级-客户升级
	CustomerUpgrade(params){
		return axios.get(`${base.baseURL}/Customer/upgrade?customerId=${params.customerId}&type=${params.type}&goodsId=${params.goodsId}&actualPrice=${params.actualPrice}`);
	},
	// 客户变更
	CustomerAlter(customerId,userId){
		return axios.get(`${base.baseURL}/Customer/alter?customerId=${customerId}&userId=${userId}`);
	},


  // 客户数量统计(某年某月按照天分组)-客户统计
  CustomerSelectCustomerByYearAndMonth(year, month, type){
  	return axios.get(`${base.baseURL}/Customer/selectCustomerByYearAndMonth?year=${year}&month=${month}&type=${type}`);
  },
  // 客户数量统计(某年按照月分组)-客户统计
  CustomerSelectCustomerByYear(year, type){
  	return axios.get(`${base.baseURL}/Customer/selectCustomerByYear?year=${year}&type=${type}`);
  },
  // 客户数量统计(照年分组)-客户统计
  CustomerSelectCustomer(type){
  	return axios.get(`${base.baseURL}/Customer/selectCustomer?type=${type}`);
  },
  // 客户数量统计(type分组)-客户统计
  CustomerSelectCustomerByType(){
  	return axios.get(`${base.baseURL}/Customer/selectCustomerByType`);
  },
  // 客户数量统计(Turnover分组)-客户统计
  CustomerSelectCustomerByTurnover(){
  	return axios.get(`${base.baseURL}/Customer/selectCustomerByTurnover`);
  },
  // 服务记录
	// 分页请求所有数据-服务记录
	CustomerServerRecordPage(params){
		return axios.post(`${base.baseURL}/CustomerServerRecord/page`,params);
	},
	// 新增数据-服务记录
	CustomerServerRecordInsert(params){
		return axios.post(`${base.baseURL}/CustomerServerRecord/insert`,params);
	},
	// 修改数据-服务记录
	CustomerServerRecordUpdate(params){
		return axios.post(`${base.baseURL}/CustomerServerRecord/update`,params);
	},
	// 删除数据-服务记录
	CustomerServerRecordDeleteById(id){
		return axios.post(`${base.baseURL}/CustomerServerRecord/delete/${id}`);
	},
}
export default custom;



// WEBPACK FOOTER //
// ./src/network/custom.js